import { isAfter } from 'date-fns';
import { DateRange } from '../types';

export function getHighlightedDates(draftDates: DateRange, hoverDate: Date | undefined): DateRange {
  const { startDate, endDate } = draftDates;
  if (startDate && endDate) {
    return { startDate: startDate, endDate: endDate };
  }

  if (startDate && hoverDate && isAfter(hoverDate, startDate)) {
    return { startDate: startDate, endDate: hoverDate };
  }

  return { startDate: undefined, endDate: undefined };
}
